import { ChevronUpIcon } from './ChevronUpIcon';

/**
 * author: Google
 * id AECCC94F-C38A-4A97-879E-ACD09F89169A
 * name chevron-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-up.svg
 * tags
 * - Arrow 
 * - Math 
 */
export const KeyboardArrowUpIcon = ChevronUpIcon;
export default KeyboardArrowUpIcon